import { ParamService } from "src/app/services/param.service";
import { PoolService } from "src/app/services/pool.service";
import { AuthService } from "src/app/services/auth.service";
import { Component, OnInit, HostListener } from "@angular/core";
import { Moment } from "moment";
declare var require: any;
const moment = require("moment");
require("moment/locale/tr");

export interface Language {
  label: string;
  labelName: string;
}

export interface LanguageMap {
  [key: string]: Language;
}

export interface UserElement {
  sicil: string;
  name: string;
  gorev: string;
  totalShift?: string;
  [key: string]: any;
}

export interface EmployeeShiftItemDto {
  employeeId: number;
  date: string; // YYYY-MM-DD formatında göndermek en güvenlisidir
  shiftId: number;
}

export interface ShiftSaveDto {
  companyId: number;
  startDate: string;
  endDate: string;
  employeeShifts: EmployeeShiftItemDto[];
}

@Component({
  selector: "app-shift-scheduler",
  templateUrl: "./shift-scheduler.component.html",
  styleUrls: ["./shift-scheduler.component.scss"],
})
export class ShiftSchedulerComponent implements OnInit {
  user: string = "";
  userType: string = "";
  language: any = [];
  languageMap: LanguageMap = {};
  prmShiftControl: boolean = true;
  prmShiftHour: number = 45;
  prmShiftPartHour: number = 30;
  prmShiftPartHourTasks: string = "Stajyer";
  companyId: number = Number(sessionStorage.getItem("companyid"));
  currentWeekStartDate!: Moment;
  shiftDates: string[] = [];
  usrDataSource: UserElement[] = [];

  tableMouseDown: { rowId: number; colId: number } | null = null;
  tableMouseUp: { rowId: number; colId: number } | null = null;
  isDragging: boolean = false;

  totals: number[][] = [];
  totalsCalc: number[][] = [];
  totalAmount: number[] = [];

  shiftsList: any[] = [];
  activeSelectedShift: string = ""; // İlk başta boş, DB'den gelen ilk veriyle dolacak

  constructor(
    private paramService: ParamService,
    private poolService: PoolService,
    private authService: AuthService,
  ) {}

  getLanguage(lng: any) {
    let data;
    this.paramService.getLanguageInfo().subscribe(
      (res: any) => {
        Object.keys(res).forEach((key) => {
          let data = { label: res[key].label, labelName: res[key].labelName };
          this.language.push(data);
        });

        // let languageMap: LanguageMap = {};
        this.language.forEach((s: Language) => {
          this.languageMap[s.label] = s;
        });
      },
      (err) => {
        console.log(err);
      },
    );
  }

  ngOnInit() {
    this.authService.getUserName.subscribe(
      (user) => (this.user = user ? user : ""),
    );
    this.authService.getUserType.subscribe(
      (userType) => (this.userType = userType ? userType : ""),
    );

    this.getLanguage(JSON.parse(localStorage.getItem("language")!).id);
    moment.locale("tr");
    this.currentWeekStartDate = moment().startOf("isoWeek");
    this.generateWeekColumns();
    this.loadEmployeesAndShifts();
  }

  // 🛠️ ANA VERİ YÜKLEME MOTORU (Eksiksiz Entegrasyon)
  loadEmployeesAndShifts() {
    // 1. Adım: API'den Şirket Personellerini Çek
    // this.user, this.userType
    this.poolService.getActiveShiftWorkers(this.companyId).subscribe(
      (employees: any = []) => {
        console.log(employees);
        if (employees && employees.length > 0) {
          // API'den gelen personel listesini UserElement modeline map ediyoruz
          this.usrDataSource = employees.map((emp: any) => ({
            sicil: emp.sicilNo || emp.sicil || emp.id.toString(), // API'deki alan adınıza göre güncelleyin
            name: emp.fullName || emp.name,
            gorev: emp.title || emp.gorev || "Belirtilmemiş",
            totalShift: "0:00",
          }));

          // 2. Adım: Personel listesi oluştuktan sonra matrisi bellekte ilklendir
          this.initMatrix();

          // 3. Adım: Şimdi veritabanındaki haftalık planlanmış vardiyaları çek
          this.fetchDataForWeek();
        } else {
          this.usrDataSource = [];
          this.initMatrix();
          console.warn("Bu şirkete ait personel bulunamadı.");
        }
      },
      (err) => {
        console.error("Personel listesi yüklenirken teknik hata:", err);
        alert("Personel listesi yüklenemedi.");
      },
    );
  }

  // 🛠️ VERİLERİ PAKETLEYİP API'YE GÖNDEREN METOT
  saveShifts() {
    const employeeShifts: EmployeeShiftItemDto[] = [];

    // Matristeki her personeli ve her günü dönerek DTO listesini dolduruyoruz
    for (let i = 0; i < this.usrDataSource.length; i++) {
      const user = this.usrDataSource[i];
      // Personel sicil numarasını numeric id'ye çeviriyoruz (Veritabanınız long EmployeeId bekliyor)
      const empId = Number(user.sicil);

      for (let j = 0; j < this.shiftDates.length; j++) {
        const dateStr = this.shiftDates[j]; // DD-MM-YYYY formatındaki kolon adı
        const cellValue = user[dateStr];

        // API'nin tanıması için tarihi YYYY-MM-DD formatına dönüştürüyoruz
        const formattedDate = moment(dateStr, "DD-MM-YYYY").format(
          "YYYY-MM-DD",
        );

        let targetShiftId: number | null = null;

        // 3. Eğer hücre boş değilse, eldeki vardiya listesinden metne uygun olan ID'yi buluyoruz
        if (cellValue && cellValue !== "-") {
          const foundShift = this.shiftsList.find(
            (s) => s.shiftCode === cellValue.split("*")[0],
          );
          if (foundShift) {
            targetShiftId = foundShift.id; // Veritabanındaki gerçek long ShiftId değeri
          }
        }
        // Eğer hücrede bir vardiya kodu varsa listeye ekle
        // Boş hücreleri de sildirmek istiyorsak (ShiftCode: "") olarak gönderebiliriz, API tarafı temizleyecektir.
        employeeShifts.push({
          employeeId: empId,
          date: formattedDate,
          shiftId: targetShiftId || 0, // Hücre boşsa boş string gider, API bunu siler
        });
      }
    }

    // API'nin beklediği ana DTO yapısı
    const savePayload: ShiftSaveDto = {
      companyId: this.companyId,
      // Haftanın başlangıç ve bitiş tarihlerini API'ye gönderiyoruz
      startDate: this.currentWeekStartDate.format("YYYY-MM-DD"),
      endDate: moment(this.currentWeekStartDate)
        .endOf("isoWeek")
        .format("YYYY-MM-DD"),
      employeeShifts: employeeShifts,
    };

    // Servis üzerinden HTTP POST isteğini ateşliyoruz
    this.poolService.saveWeeklyShifts(savePayload).subscribe(
      (res: any) => {
        if (res && res.status === "SUCCESS") {
          alert(res.message || "Vardiya tablosu başarıyla kaydedildi.");
          // Başarılı kayıttan sonra isterseniz güncel veriyi tekrar çekebilirsiniz
          this.fetchDataForWeek();
        } else {
          alert("Kayıt başarısız: " + (res.message || "Bilinmeyen hata"));
        }
      },
      (err) => {
        console.error(err);
        alert("Sunucuyla iletişim kurulurken teknik bir hata oluştu.");
      },
    );
  }
  generateWeekColumns() {
    this.shiftDates = [];
    const tempDate = moment(this.currentWeekStartDate);
    for (let i = 0; i < 7; i++) {
      this.shiftDates.push(tempDate.format("DD-MM-YYYY"));
      tempDate.add(1, "days");
    }

    // 🚀 MASTER YÜKLEME DÖNGÜSÜ BAŞLIYOR: Önce Vardiyaları, sonra Personeli ve Planları çekeceğiz
    this.loadAllDataFromDb();
  }

  loadAllDataFromDb() {
    // 1. ADIM: Veritabanından Şirkete Ait Aktif Vardiya Tanımlarını Çek
    this.poolService.getActiveShifts(this.companyId).subscribe(
      (shifts: any[]) => {
        this.shiftsList = shifts || [];

        // Eğer veritabanında vardiya varsa, üstteki select box için ilk vardiyayı varsayılan seç
        if (this.shiftsList.length > 0) {
          const first = this.shiftsList[0];
          // Formatımızı koruyoruz: "VardiyaAdi#Id#MaxClim"
          this.activeSelectedShift =
            first.id +
            "#" +
            first.shiftCode +
            "#" +
            first.shiftName +
            "#" +
            first.maxClim;
        }

        // 2. ADIM: Vardiyalar yüklenince Personel Listesini Çek
        this.loadEmployeesAndShifts();
      },
      (err) => {
        console.error("Vardiya tanımları DB'den çekilemedi:", err);
      },
    );
  }

  nextWeek() {
    this.currentWeekStartDate.add(1, "weeks");
    this.clearSelection();
    this.generateWeekColumns();
  }

  previousWeek() {
    this.currentWeekStartDate.subtract(1, "weeks");
    this.clearSelection();
    this.generateWeekColumns();
  }

  getWeekRangeLabel(): string {
    const endOfWeek = moment(this.currentWeekStartDate).endOf("isoWeek");
    return (
      this.currentWeekStartDate.format("DD MMMM YYYY") +
      " - " +
      endOfWeek.format("DD MMMM YYYY")
    );
  }

  // 🛠️ TÜM TÜRLERİ DÜZGÜN ARRAY FORMATINA GETİRDİK
  initMatrix() {
    this.totals = [];
    this.totalAmount = [];
    for (let i = 0; i < this.usrDataSource.length; i++) {
      this.totals[i] = [];
      this.totalAmount[i] = 0;
      for (let j = 0; j < this.shiftDates.length; j++) {
        this.totals[i][j] = 0;
        const dateKey = this.shiftDates[j];
        this.usrDataSource[i][dateKey] = "";
      }
      this.usrDataSource[i].totalShift = "0:00";
    }
  }

  isCellSelected(rowIndex: number, colIndex: number): boolean {
    if (!this.tableMouseDown || !this.tableMouseUp) {
      return false;
    }
    const startRow = Math.min(
      this.tableMouseDown.rowId,
      this.tableMouseUp.rowId,
    );
    const endRow = Math.max(this.tableMouseDown.rowId, this.tableMouseUp.rowId);
    const startCol = Math.min(
      this.tableMouseDown.colId,
      this.tableMouseUp.colId,
    );
    const endCol = Math.max(this.tableMouseDown.colId, this.tableMouseUp.colId);
    return (
      rowIndex >= startRow &&
      rowIndex <= endRow &&
      colIndex >= startCol &&
      colIndex <= endCol
    );
  }

  // 🛠️ %100 ÇALIŞAN MOBİL DOKUNMATİK SEÇİM / TOGGLE MOTORU
  onMobileTouch(rowIndex: number, colIndex: number) {
    const dateKey = this.shiftDates[colIndex];
    const currentVal = this.usrDataSource[rowIndex][dateKey];

    // Eğer hücre doluysa veya zaten bu hücre seçiliyse: BOŞALTMA (TOGGLE)
    if (
      currentVal !== "" ||
      (this.tableMouseDown &&
        this.tableMouseDown.rowId === rowIndex &&
        this.tableMouseDown.colId === colIndex)
    ) {
      this.tableMouseDown = { rowId: rowIndex, colId: colIndex };
      this.tableMouseUp = { rowId: rowIndex, colId: colIndex };
      this.updateSelectedCellsValues(""); // Hücreyi temizle
      this.clearSelection();
    } else {
      // Hücre boşsa: SEÇ VE YAZ
      this.tableMouseDown = { rowId: rowIndex, colId: colIndex };
      this.tableMouseUp = { rowId: rowIndex, colId: colIndex };
      if (this.activeSelectedShift) {
        this.updateSelectedCellsValues(this.activeSelectedShift);
      }
    }
  }

  // Masaüstü Sürükleme Başlangıcı
  onMouseDown(rowIndex: number, colIndex: number) {
    this.isDragging = true;
    this.tableMouseDown = { rowId: rowIndex, colId: colIndex };
    this.tableMouseUp = { rowId: rowIndex, colId: colIndex };
  }

  // Masaüstü Sürükleme Hareketi
  onMouseEnter(rowIndex: number, colIndex: number) {
    if (this.isDragging && this.tableMouseDown) {
      this.tableMouseUp = { rowId: rowIndex, colId: colIndex };
    }
  }

  // Masaüstü Sürükleme Bitişi
  onMouseUp() {
    if (this.isDragging) {
      this.isDragging = false;
      if (this.activeSelectedShift) {
        this.updateSelectedCellsValues(this.activeSelectedShift);
      }
    }
  }

  onShiftTypeChange() {
    if (this.tableMouseDown && this.tableMouseUp && this.activeSelectedShift) {
      this.updateSelectedCellsValues(this.activeSelectedShift);
    }
  }

  @HostListener("document:keyup", ["$event"])
  onKeyUp(event: KeyboardEvent): void {
    if (!this.tableMouseDown || !this.tableMouseUp) {
      return;
    }
    if (event.key === "Backspace" || event.key === "Delete") {
      this.updateSelectedCellsValues("");
      return;
    }
  }

  updateSelectedCellsValues(shiftDataString: string) {
    if (!this.tableMouseDown || !this.tableMouseUp) {
      return;
    }

    let shiftText = "";
    let shiftMinute = 0;
    let shiftId = 0; // 🛠️ ID takibi için eklendi

    if (shiftDataString && shiftDataString.indexOf("#") > -1) {
      const parts = shiftDataString.split("#");
      shiftText = parts[1] + "*" + parts[2];
      shiftId = Number(parts[1]) || 0; // Veritabanına gidecek olan ShiftId
      shiftMinute = Number(parts[3]) || 0; // Limit hesabına girecek olan MaxClim dakikası
    }

    const startRow = Math.min(
      this.tableMouseDown.rowId,
      this.tableMouseUp.rowId,
    );
    const endRow = Math.max(this.tableMouseDown.rowId, this.tableMouseUp.rowId);
    const startCol = Math.min(
      this.tableMouseDown.colId,
      this.tableMouseUp.colId,
    );
    const endCol = Math.max(this.tableMouseDown.colId, this.tableMouseUp.colId);

    this.totalsCalc = JSON.parse(JSON.stringify(this.totals));
    const dataCopy = this.usrDataSource.slice();

    // Geçici hesaplama matrisine yeni dakikaları işlet
    for (let i = startRow; i <= endRow; i++) {
      for (let j = startCol; j <= endCol; j++) {
        if (this.totalsCalc[i]) {
          this.totalsCalc[i][j] = shiftMinute;
        }
      }
    }

    // Haftalık limit aşım kontrolü süzgeci
    for (let i = 0; i < dataCopy.length; i++) {
      this.totalAmount[i] = 0;
      if (this.totalsCalc[i]) {
        for (let j = 0; j < this.totalsCalc[i].length; j++) {
          this.totalAmount[i] += this.totalsCalc[i][j];
        }
      }
    }

    let hasLimitError = false;
    let errorTaskMsg = "";
    if (this.prmShiftControl) {
      for (let i = startRow; i <= endRow; i++) {
        const allowedHour =
          dataCopy[i].gorev === this.prmShiftPartHourTasks
            ? this.prmShiftPartHour
            : this.prmShiftHour;
        if (this.totalAmount[i] > allowedHour * 60) {
          hasLimitError = true;
          errorTaskMsg = dataCopy[i].gorev;
          break;
        }
      }
    }

    if (hasLimitError) {
      const limitVal =
        errorTaskMsg === this.prmShiftPartHourTasks
          ? this.prmShiftPartHour
          : this.prmShiftHour;
      alert("Aynı hafta içinde " + limitVal + " saat sınırı aşılmıştır!");
      this.clearSelection();
      return;
    }

    // Değişiklikler yasal sınırda ise hücre metinlerini güncelle
    for (let i = startRow; i <= endRow; i++) {
      for (let j = startCol; j <= endCol; j++) {
        const dateKey = this.shiftDates[j];
        // 🚨 ÖNEMLİ: Ekranda kısa adı gösteriyoruz ancak hücrenin arka planında
        // kaydetme fonksiyonunun (saveShifts) okuyabilmesi için ID bilgisini de saklayabiliriz.
        // En temizi hücreye direkt kısa adı yazıp, save aşamasında activeSelectedShift'ten ID'yi çözmektir.
        dataCopy[i][dateKey] = shiftText;

        // Save metodunuzun hangi hücreye hangi ID'nin atandığını bilmesi için
        // isterseniz hücre verisini nesne olarak da tutabilirsiniz. Ancak düz metin tutuyorsanız,
        // saveShifts() metodunda elinizdeki vardiya listesinden metne göre ID buldurabilirsiniz.
      }
    }

    this.totals = JSON.parse(JSON.stringify(this.totalsCalc));
    this.recalculateTotalHours();
    this.usrDataSource = dataCopy;
  }

  clearSelection() {
    this.tableMouseDown = null;
    this.tableMouseUp = null;
    this.isDragging = false;
  }

  fetchDataForWeek() {
    const startStr = this.currentWeekStartDate.format("YYYY-MM-DD");
    const endStr = moment(this.currentWeekStartDate)
      .endOf("isoWeek")
      .format("YYYY-MM-DD");

    // Önce ekranı ve hesaplama matrisini sıfırlıyoruz
    this.initMatrix();

    this.poolService
      .getWeeklyShifts(this.companyId, startStr, endStr)
      .subscribe(
        (dbShifts) => {
          if (dbShifts && dbShifts.length > 0) {
            // Veritabanından gelen her bir vardiya kaydını matrise eşliyoruz
            dbShifts.forEach((shift: any) => {
              // Personeli matriste bul (sicil ve EmployeeId eşleşmesi)
              const userRowIndex = this.usrDataSource.findIndex(
                (u) => Number(u.sicil) === shift.employeeId,
              );

              if (userRowIndex > -1) {
                // Tarihi kolon formatımıza (DD-MM-YYYY) çevir ve indeksini tespit et
                const cellDateKey = moment(shift.date).format("DD-MM-YYYY");
                const colIndex = this.shiftDates.indexOf(cellDateKey);

                if (colIndex > -1) {
                  // 🛠️ YENİ DİNAMİK YAPI: Backend'den gelen değerleri direkt matrise gömüyoruz
                  // Arayüzde görünecek kısa isim (Örn: "GM H.ICI")
                  this.usrDataSource[userRowIndex][cellDateKey] =
                    shift.shiftCode + "*" + shift.shiftName;

                  // Haftalık toplam hesaplama matrisine (totals) DB'den gelen canlı MaxClim dakikasını yaz
                  if (this.totals[userRowIndex]) {
                    this.totals[userRowIndex][colIndex] = shift.maxClim;
                  }
                }
              }
            });

            // Tüm eşleşmeler bittikten sonra personellerin toplam saat yazılarını (SS:DD) hesapla
            this.recalculateTotalHours();
          }
        },
        (err) => {
          console.error("Veri yüklenirken hata oluştu:", err);
        },
      );
  }

  // Yardımcı Saat Hesaplama Metodu
  private recalculateTotalHours() {
    this.usrDataSource.forEach((user, rowIndex) => {
      let totalMinutes = 0;
      this.totals[rowIndex].forEach((min) => (totalMinutes += min));

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      user.totalShift = hours + ":" + (minutes < 10 ? "0" + minutes : minutes);
    });
  }
}
